/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable import/no-cycle */
import type React from 'react';

import * as styles from './styles';
import type { SvgIconProps } from '@material-ui/core';

import { Button } from '@cobliteam/ui/components';

import { NotificationsIcon } from '../icons';

import { CloseButton, type CloseButtonProps } from '../Button';
import { colors } from '../styles';

interface ReminderPanelProps {
  children: React.ReactNode;
  className?: string;
  textClassName?: string;
  actionText?: string;
  Icon?:
    | React.FunctionComponent<React.SVGProps<SVGSVGElement>>
    | ((props: SvgIconProps) => JSX.Element);
  iconClassName?: string;
  closeButtonProps?: CloseButtonProps;
  optionalBodyText?: React.ReactNode;
  onClickClose?: () => void;
  onActionButtonClick?: () => void;
}

export const ReminderPanel: React.FC<ReminderPanelProps> = ({
  children,
  className,
  textClassName,
  actionText,
  iconClassName,
  onClickClose,
  onActionButtonClick,
  Icon = NotificationsIcon,
  optionalBodyText,
  closeButtonProps,
}) => (
  <div className={`${styles.panelWrapper} ${className || ''}`}>
    <div className={styles.contentWrapper}>
      <div className={styles.items}>
        <Icon className={`${styles.iconWrapper} ${iconClassName || ''}`} />
        <div className={`${styles.infoText} ${textClassName || ''}`}>
          {children}
        </div>
      </div>
      {optionalBodyText && optionalBodyText}
    </div>
    <div className={styles.items}>
      {actionText && (
        <Button
          variant='text'
          className='min-w-36'
          onClick={onActionButtonClick}
        >
          {actionText}
        </Button>
      )}
      {onClickClose && (
        <CloseButton
          fill={colors.white}
          hoverFill={colors.gray.light}
          hoverBackground={colors.accessory._6}
          className={styles.closeButton}
          onClick={onClickClose}
          {...closeButtonProps}
        />
      )}
    </div>
  </div>
);
